"use client";

import { useTranslation } from "react-i18next";

import { getDateStringLocale } from "@/i18n/getDateFnsLocale.ts";

interface CalendarTimeColumnProps {
  hours: number[];
  minHour: number;
  hourHeight: number;
}

export function CalendarTimeColumn({ hours, minHour, hourHeight }: CalendarTimeColumnProps) {
  const { i18n } = useTranslation();

  return (
    <div className="bg-background relative z-50 h-full">
      {hours.map((hour) => (
        <div
          key={hour}
          className="absolute box-border flex w-full text-center"
          style={{
            top: `${(hour - minHour) * hourHeight}px`,
            height: `${hourHeight}px`,
          }}
        >
          <div
            className={`relative ${hour !== 0 && "-top-2.5"} text-muted-foreground px-2 text-center text-sm`}
          >
            {new Date(new Date().setHours(hour, 0, 0, 0)).toLocaleTimeString(
              getDateStringLocale(i18n.language),
              {
                hour: "numeric",
                minute: "2-digit",
              },
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
